var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMultipleChoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.769 6.74a3.066 3.066 0 100-6.131 3.066 3.066 0 000 6.131z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.203 3.675h27.501",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.769 22.917a3.066 3.066 0 100-6.132 3.066 3.066 0 000 6.132z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.203 19.853h27.501",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.769 39.24a3.066 3.066 0 100-6.131 3.066 3.066 0 000 6.131z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.203 36.174h27.501",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0OCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0zLjc2ODg5IDYuNzQwMjNDNS40NjIwNyA2Ljc0MDIzIDYuODM0NjYgNS4zNjc1OCA2LjgzNDY2IDMuNjc0MzJDNi44MzQ2NiAxLjk4MTA2IDUuNDYyMDcgMC42MDgzOTggMy43Njg4OSAwLjYwODM5OEMyLjA3NTcyIDAuNjA4Mzk4IDAuNzAzMTI1IDEuOTgxMDYgMC43MDMxMjUgMy42NzQzMkMwLjcwMzEyNSA1LjM2NzU4IDIuMDc1NzIgNi43NDAyMyAzLjc2ODg5IDYuNzQwMjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik0xOC4yMDMxIDMuNjc0NUg0NS43MDQxIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik0zLjc2ODg5IDIyLjkxNjlDNS40NjIwNyAyMi45MTY5IDYuODM0NjYgMjEuNTQ0MiA2LjgzNDY2IDE5Ljg1MUM2LjgzNDY2IDE4LjE1NzcgNS40NjIwNyAxNi43ODUgMy43Njg4OSAxNi43ODVDMi4wNzU3MiAxNi43ODUgMC43MDMxMjUgMTguMTU3NyAwLjcwMzEyNSAxOS44NTFDMC43MDMxMjUgMjEuNTQ0MiAyLjA3NTcyIDIyLjkxNjkgMy43Njg4OSAyMi45MTY5WiIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMTguMjAzMSAxOS44NTNINDUuNzA0MSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMy43Njg4OSAzOS4yNDAyQzUuNDYyMDcgMzkuMjQwMiA2LjgzNDY2IDM3Ljg2NzYgNi44MzQ2NiAzNi4xNzQzQzYuODM0NjYgMzQuNDgxMSA1LjQ2MjA3IDMzLjEwODQgMy43Njg4OSAzMy4xMDg0QzIuMDc1NzEgMzMuMTA4NCAwLjcwMzEyNSAzNC40ODExIDAuNzAzMTI1IDM2LjE3NDNDMC43MDMxMjUgMzcuODY3NiAyLjA3NTcxIDM5LjI0MDIgMy43Njg4OSAzOS4yNDAyWiIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMTguMjAzMSAzNi4xNzM2SDQ1LjcwNDEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgMultipleChoice as ReactComponent };